
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Part, Workorder } from 'performo-api';

import AdvancedPartPicker from '@/components/parts/PartPicker.vue';

@Component({
  components: {
    AdvancedPartPicker
  }
})
export default class AddInventoryPartComponent extends Vue {
  @Prop({ required: false })
  private disabled!: boolean;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({})
  startingParts!: Part[];

  private pickedParts!: Part[];

  data() {
    return {
      pickedParts: []
    };
  }

  async mounted() {
    this.pickedParts = [];
  }

  returnPicks() {
    this.$emit('picks-changed', this.pickedParts);
    this.cancelPart();
  }

  cancelPart() {
    this.pickedParts = [];
    this.popoverOpen = false;
  }
  private popoverOpen = false;
}
